import React, { useEffect } from "react";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import { useAppSelector } from "custom-hooks/redux.hooks";
import { CPagesPath } from "shared/models/const/pages-path";
import UserSettingsLayout from "shared/layouts/user-settings";
import styled from "@emotion/styled";
import FavoritesListInfinite from "@components-pages/favorites-properties/favorites-list-infinite";
import { FavActionMadeFromList } from "shared/context/show-fav-action-snackbar.context";
import { en, es } from "@lang";
import LastedSeeProperty from "@components-pages/lastend-see-properties/favorites-list-infinite";
import { Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

function HistorySearch(props: any) {
  const titleT = useTranslations("title-pages");
  const t = useTranslations("ProfileHistorySearchPage");
  const router = useRouter();
  const user = useAppSelector((state) => state.Auth.user);

  useEffect(() => {
    if (!user) router.push(CPagesPath.es.signin);
  });

  if (!user) return null;

  return (
    <>
      <Head>
        <title>{titleT("profile-historial_search")}</title>
      </Head>
      <Container>
        <h1>
          {t("title")}
          <Tooltip title={t("description")}>
            <HelpOutlineIcon />
          </Tooltip>
        </h1>
        <FavActionMadeFromList.Provider value={false}>
          <LastedSeeProperty />
        </FavActionMadeFromList.Provider>
      </Container>
    </>
  );
}

HistorySearch.Layout = UserSettingsLayout;
export default HistorySearch;

const Container = styled.section`
  display: grid;
  place-content: center;
  grid-template-columns: 1fr;
  max-width: var(--list-max-width);
  margin: auto;
  padding: 30px 20px;

  h1 {
    color: var(--color-brand-blue-main);
    display: flex;
    align-items: center;
    column-gap: 4px;
  }
`;
